var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Icon, Select } from '@gerdau/hefesto';
import './Pagination.scss';
import { Pagination as MuiPagination, PaginationItem, } from '@mui/material';
var Pagination = function (_a) {
    var ariaLabel = _a.ariaLabel, onChange = _a.onChange, _b = _a.pageSizeOptions, pageSizeOptions = _b === void 0 ? [10, 20, 50] : _b, _c = _a.select, select = _c === void 0 ? true : _c, selectedPage = _a.selectedPage, selectedPageSizeOption = _a.selectedPageSizeOption, _d = _a.showTotal, showTotal = _d === void 0 ? true : _d, total = _a.total;
    var _e = useState(selectedPageSizeOption && pageSizeOptions.includes(selectedPageSizeOption)
        ? selectedPageSizeOption
        : pageSizeOptions[0]), currentPageSize = _e[0], setCurrentPageSize = _e[1];
    var numberOfPages = total / currentPageSize <= 1 ? 1 : Math.ceil(total / currentPageSize);
    var getInitialPage = function () {
        if (selectedPage) {
            if (selectedPage > numberOfPages) {
                return numberOfPages;
            }
            else if (selectedPage < 0) {
                return 1;
            }
            else {
                return selectedPage;
            }
        }
        return 1;
    };
    var _f = useState(getInitialPage()), currentPage = _f[0], setCurrentPage = _f[1];
    var _g = useState(true), disabledPrev = _g[0], setDisabledPrev = _g[1];
    var _h = useState(false), disabledNext = _h[0], setDisabledNext = _h[1];
    var _j = useState(true), disabledGoto = _j[0], setDisabledGoto = _j[1];
    var _k = useState(), pageGoto = _k[0], setPageGoto = _k[1];
    useEffect(function () {
        onChangePage(currentPage);
    }, []);
    var optionsWithDesc = pageSizeOptions.map(function (pageSize) { return ({ value: String(pageSize), label: "".concat(pageSize, "/p\u00E1gina") }); });
    var handlePageGoto = function (page) {
        if (page && Number(page) <= total / currentPageSize) {
            var pageNumber = Number(page);
            setPageGoto(pageNumber);
        }
    };
    var closeInputGoto = function (e) {
        if (e.key === 'Escape') {
            setDisabledGoto(true);
        }
        if (e.key === 'Enter') {
            handleGotoSubmit();
        }
    };
    var handleGotoSubmit = function () {
        if (pageGoto) {
            setDisabledGoto(true);
            onChangePage(pageGoto);
        }
    };
    var inputGoto = function () {
        return (_jsxs("div", __assign({ className: "hefesto-pagination__c" }, { children: [_jsx("input", { placeholder: "Ir para...", className: "hefesto-pagination__input", autoFocus: true, onChange: function (e) {
                        return handlePageGoto(e.target.value);
                    }, onKeyDown: function (e) { return closeInputGoto(e); }, name: 'inputPagination' }), _jsx("div", __assign({ onClick: function () { return handleGotoSubmit(); }, className: "hefesto-pagination__item hefesto-pagination__item--submit" }, { children: _jsx(Icon, { variant: "primary", option: "ArrowRight" }) }))] })));
    };
    var renderItem = function (params) {
        var noLength = total === 0;
        if (params.type === 'previous') {
            return (_jsxs("div", __assign({ className: "hefesto-pagination__prev" }, { children: [_jsx("div", __assign({ "data-testid": "hefesto-pagination-prev", onClick: function () { return onChangePage(1); }, className: "hefesto-pagination__item ".concat(disabledPrev || noLength
                            ? 'hefesto-pagination__item--disabled'
                            : '') }, { children: _jsx(Icon, { variant: "primary", option: "ArrowLeftDouble" }) })), _jsx("div", __assign({ "data-testid": "hefesto-pagination-prev-one-page", onClick: function () {
                            return onChangePage(currentPage !== 1 ? currentPage - 1 : 1);
                        }, className: "hefesto-pagination__item ".concat(disabledPrev || noLength
                            ? 'hefesto-pagination__item--disabled'
                            : '') }, { children: _jsx(Icon, { variant: "primary", option: "ArrowLeft" }) }))] })));
        }
        if (params.type === 'next') {
            return (_jsxs("div", __assign({ className: "hefesto-pagination__next" }, { children: [_jsx("div", __assign({ "data-testid": "hefesto-pagination-next-one-page", onClick: function () {
                            return onChangePage(currentPage !== total / currentPageSize
                                ? currentPage + 1
                                : currentPage);
                        }, className: "hefesto-pagination__item ".concat(disabledNext || noLength
                            ? 'hefesto-pagination__item--disabled'
                            : '') }, { children: _jsx(Icon, { variant: "primary", option: "ArrowRight" }) })), _jsx("div", __assign({ "data-testid": "hefesto-pagination-next", onClick: function () { return onChangePage(total / currentPageSize); }, className: "hefesto-pagination__item ".concat(disabledNext || noLength
                            ? 'hefesto-pagination__item--disabled'
                            : '') }, { children: _jsx(Icon, { variant: "primary", option: "ArrowRightDouble" }) }))] })));
        }
        if (params.type === 'page') {
            if (disabledGoto) {
                return (_jsx(PaginationItem, __assign({}, params, { onClick: function () { return onChangePage(params.page); }, disabled: noLength })));
            }
            if (params.page === 1 || params.page === total / currentPageSize) {
                return (_jsx(PaginationItem, __assign({}, params, { onClick: function () { return onChangePage(params.page); }, disabled: noLength })));
            }
            return _jsx(_Fragment, {});
        }
        if (params.type === 'end-ellipsis') {
            return (_jsx("div", __assign({ onClick: function () {
                    return disabledGoto ? setDisabledGoto(!disabledGoto) : undefined;
                } }, { children: disabledGoto ? (_jsx(PaginationItem, __assign({}, params, { disabled: noLength }))) : (inputGoto()) })));
        }
        if (params.type === 'start-ellipsis') {
            var elementEllipsis = document.getElementsByClassName("MuiPaginationItem-ellipsis");
            var elementInput = document.getElementsByClassName("hefesto-pagination__input");
            if (!disabledGoto &&
                (elementEllipsis.length > 1 || elementInput.length)) {
                return _jsx(_Fragment, {});
            }
            return (_jsx("div", __assign({ onClick: function () {
                    return disabledGoto ? setDisabledGoto(!disabledGoto) : undefined;
                } }, { children: disabledGoto ? (_jsx(PaginationItem, __assign({}, params, { disabled: noLength }))) : (inputGoto()) })));
        }
        return _jsx(PaginationItem, __assign({}, params, { disabled: noLength }));
    };
    var onChangePage = function (page, pageSize) {
        if (pageSize === void 0) { pageSize = currentPageSize; }
        if (page) {
            setDisabledNext(false);
            setDisabledPrev(false);
            if (Math.ceil(page) === Math.ceil(total / pageSize)) {
                setDisabledNext(true);
            }
            if (page === 1) {
                setDisabledPrev(true);
            }
            setCurrentPage(Math.ceil(page));
            setDisabledGoto(true);
            onChange(page, pageSize);
        }
    };
    return (_jsxs("div", __assign({ className: "hefesto-pagination hefesto-pagination__container" }, { children: [select ? (_jsx("div", __assign({ className: "hefesto-pagination__select" }, { children: _jsx(Select, { label: "Quantidade de itens por p\u00E1gina", name: "selectPagination", "data-testid": "comboboxID", options: optionsWithDesc, onSelect: function (selectValue) {
                        var selectedPageSize = Number(selectValue);
                        setCurrentPageSize(selectedPageSize);
                        onChangePage(1, selectedPageSize);
                    }, value: currentPageSize.toString(), hideLabel: true }) }))) : (_jsx(_Fragment, {})), showTotal ? (_jsx("div", __assign({ className: "hefesto-pagination__text" }, { children: total === 0 ? (_jsx("span", { children: "Nenhum item foi encontrado" })) : (_jsx("span", { children: "Exibindo de ".concat((currentPage - 1) * currentPageSize + 1, " a ").concat(currentPage * currentPageSize < total
                        ? currentPage * currentPageSize
                        : total, " do total de ").concat(total) })) }))) : (_jsx(_Fragment, {})), _jsx(MuiPagination, { "aria-label": ariaLabel, variant: "outlined", page: currentPage, onChange: function (_, page) { return setCurrentPage(page); }, renderItem: renderItem, size: "large", shape: "rounded", count: numberOfPages })] })));
};
export default Pagination;
